import api from './api';
import { setMediaPublicOrigin } from '../utils/mediaUrl';

let loadPromise = null;

/**
 * Fetches GET /api/site-config/ once (PUBLIC_CUSTOMER_API_URL as media_origin).
 */
export function ensureMediaOriginLoaded() {
  if (loadPromise) {
    return loadPromise;
  }
  loadPromise = api
    .get('/site-config/')
    .then((res) => {
      const mo = res.data?.media_origin;
      if (mo) {
        setMediaPublicOrigin(mo);
      }
    })
    .catch(() => {
      /* non-fatal */
    });
  return loadPromise;
}
